import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { getRegions } from '../../../app/regions';
import {nextStep, getStep} from '../../steps';
import {resetOrder, updateOrder} from '../../order';
import Button from '../../../../ui/Button';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../ui/Select';
import styles from './css/Region.scss';
import ValidationErrors from '../../components/ValidationErrors';
import {withRouter} from "react-router-dom";

@injectIntl
export class RegionStep extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        regions: PropTypes.any,
        order: PropTypes.any,
        step: ImmutablePropTypes.map.isRequired,
        intl: intlShape.isRequired,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.dispatch(getRegions());
        const {order} = this.props;
        if (order && (order.get('positions').size !== 0) || order.get('service') || order.get('location')) {
            this.props.dispatch(resetOrder());
        }
    }

    handleNextStep = () => {
        const { step, dispatch } = this.props;
        dispatch(nextStep(step));
    }

    handleRegionSelect = (event) => {
        const { order, dispatch } = this.props;
        const value = parseInt(event.target.value, 10) || null;
        const newOrder = order.set('region', value);
        dispatch(updateOrder(newOrder));
    }

    render() {
        const { regions, order, step } = this.props;
        const { formatMessage } = this.props.intl;

        const options = regions
            .filter(region => {return !region.get('restricted')})
            .map(region => (
                Immutable.Map({ id: region.get('id'), alias: formatMessage({id: region.get('alias')}) })
            ))
            .sortBy(region => region.get('alias'))
            .map(region => (
                <option key={region.get('id')} value={region.get('id')}>
                    {region.get('alias')}
                </option>
            )).toArray();

        return (
            <div className={styles.container}>
                <div>
                    <h1>
                        <FormattedMessage id='frontend.form_selector_region.headline' />
                    </h1>
                </div>

                <ValidationErrors errors={step.get('errors')} status={step.get('state')}>
                    <FormattedMessage id='frontend.form_selector_region.validation' />
                </ValidationErrors>

                <div className={styles.content}>
                    <Select value={order.get('region') || ''} onChange={this.handleRegionSelect}>
                        <option>
                            {formatMessage({id: 'frontend.form_selector_region.select.option.region_select'})}
                        </option>
                        {options}
                    </Select>
                </div>

                <div className={styles.actions}>
                    <Button
                        block
                        disabled={!order.get('region')}
                        emphasis='primary'
                        onClick={this.handleNextStep}
                    >
                        <FormattedMessage id='frontend.form_selector_region.button.continue' />
                    </Button>
                </div>
            </div>
        );
    }
}

export default withRouter(connect((state) => ({
    regions: state.regions,
    order: state.order,
    step: getStep(state, 'region'),
}))(RegionStep));
